<script setup lang="ts">
import type { CmsElementPluebelCmsElementsHeadlineTextTwoColor } from "~/composables/useCustom";
const props = defineProps<{
  content: CmsElementPluebelCmsElementsHeadlineTextTwoColor;
}>();

const { content } = props;

const { getConfigValue } = useCmsElementConfig(content);

const greenHeadline = computed(() => getConfigValue("green_headline"));
const blackHeadline = computed(() => getConfigValue("black_headline"));
const text = computed(() => getConfigValue("text"));
</script>
<template>
  <section class="pt-10 md:pt-14 lg:pt-15 pb-10 md:pb-14 lg:pb-20">
    <div class="container">
      <div class="max-w-[1000px] w-full m-auto">
        <h2 v-if="blackHeadline || greenHeadline" class="inner-h1">
          <strong
            v-if="greenHeadline"
            class="font-bold block text-cust_green mb-1 lg:mb-2"
          >
            {{ greenHeadline }}
          </strong>
          {{ blackHeadline }}
        </h2>
        <div class="flex flex-col gap-8 paraWrap">
          <p v-if="text">
            {{ text }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
